import { useToast } from '@chakra-ui/react';
import { faAngleDoubleLeft, faSave } from '@fortawesome/free-solid-svg-icons';
import { Fragment, useState } from 'react';
import { Row } from 'react-bootstrap';
import { updateCheckers } from '../../../api/Checkers';
import setToast from '../../../libs/Toast';
import ButtonIcon from '../../layouts/ButtonIcon';
import FormIcon from '../../layouts/FormIcon';
import ModalComp from '../../layouts/Modal'

const Edit = (props) => {
    const { onClose, checker, headers, update } = props;
    const [data, setData] = useState({});
    const toast = useToast();

    const handleChange = (e) => {
        let { value, name } = e.target;
        setData({ ...data, [name]: value });
    }

    const updateCajero = async () => {
        let response = await updateCheckers({ headers, data, checker_id: checker.id });
        if (response) {
            setToast({
                toast, title: '¡Operación exitosa!', status: 'success',
                description: 'Los datos del cajero han sido actualizados con éxito.'
            });
            update();
            onClose();
        }else{
            setToast({
                toast, title: '¡Operación fallida!', status: 'warning',
                description: 'Ha ocurrido un error al tratar de actualizar los datos del cajero.'
            });
        }
    }
    return (
        <ModalComp
            title='Editar cajero'
            size='md'
            onClose={onClose}
            body={<Fragment>
                <Row className='mb-3'>
                    <FormIcon title='Nombre(s)' name='first_name' defaultValue={checker?.first_name} value={data?.first_name} handleChange={handleChange} />
                </Row>
                <Row className='mb-3'>
                    <FormIcon title='Apellido(s)' name='last_name' defaultValue={checker?.last_name} value={data?.last_name} handleChange={handleChange} />
                </Row>
                <Row className='mb-3'>
                    <FormIcon title='Correo electrónico' name='email' defaultValue={checker?.email} value={data?.email} handleChange={handleChange} />
                </Row>
                <Row className='mb-3'>
                    <FormIcon title='Contraseña' name='password' defaultValue={checker?.password} value={data?.password} type='password' handleChange={handleChange} />
                </Row>
                {/* <Row className='mb-3'>
                    <FormIcon title='Confirmar contraseña' name='passsword_confirm' value={data?.passsword_confirm} type='password' />
                </Row> */}
            </Fragment>}
            footer={<Fragment>
                <ButtonIcon name='Cerrar' icon={faAngleDoubleLeft} onClick={onClose} variant='outline-secondary' />
                <ButtonIcon name='Actualizar datos' icon={faSave} onClick={updateCajero} variant='outline-success' />
            </Fragment>}
        />
    )
}

export default Edit